import Vue from "vue";
import * as global from '../utils/global'

let installed = false
export function install(vue: typeof Vue) {
    if (installed) {
        return
    }
    vue.prototype.$global = global
    vue.mixin({
        computed: {
            G_IsDev() {
                return global.IS_DEV
            }
        }
    })
}

declare module 'vue/types/vue' {
    interface Vue {
        $global: typeof global
        G_IsDev: boolean
    }
}
